export default "__VITE_ASSET__8c429eb5__"